/**
 * Created by Abner Sui on 04/08/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TileColumn, TileColumnDataType, TileColumnSetting } from '../../../../tamalelibs/models/tile-column.model';
import { businessConstants } from '../../../../constants/business.constants';
import { BriefObject } from '../../../../tamalelibs/models/brief-object';
import { TileModel } from '../../../../tamalelibs/models/tile.model';
import { BriefConfig } from '../../../../widgets/widgets.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'tile-entry-column-detail',
    templateUrl: './tile-entry-column-detail.component.html',
    styleUrls: ['./tile-column-detail.component.scss']
})
export class TileEntryColumnDetailComponent implements OnInit, OnDestroy {

    @Input() config: TileColumn;
    @Input() wholeConfig: TileModel;
    @Input() briefConfig: BriefConfig;

    displayList: Array<BriefObject>;
    selectedDisplay: BriefObject;
    dataTypeList: Array<BriefObject> = [
        { id: 'text', value: 'Text' },
        { id: 'number', value: 'Number' },
        { id: 'currency', value: 'Currency' },
        { id: 'percent', value: 'Percent' },
        { id: 'ratio', value: 'Ratio' }
    ];
    selectedDataType: BriefObject;
    scaleList: Array<BriefObject> = [
        { id: '1', value: 'None' },
        { id: '2', value: 'Thousands' },
        { id: '3', value: 'Millions' },
        { id: '4', value: 'Billions' },
        { id: '5', value: 'Trillions' }
    ];
    selectedScale: BriefObject;
    decimalPlacesList: Array<BriefObject> = [
        { id: '0', value: '0' },
        { id: '1', value: '1' },
        { id: '2', value: '2' },
        { id: '3', value: '3' },
        { id: '4', value: '4' },
        { id: '5', value: '5' },
        { id: '6', value: '6' },
        { id: '7', value: '7' },
        { id: '8', value: '8' },
        { id: '9', value: '9' }
    ];
    selectedDecimalPlaces: BriefObject;
    hasDisplay = false;
    isNumber = false;
    isPercent = false;
    isRatio = false;
    multiplyBy100 = null;

    ngOnInit(): void {
        if (this.config.dataType === TileColumnDataType.ENTITY) {
            this.displayList = businessConstants.displayList;
            this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
            this.hasDisplay = true;
        } else if (this.config.dataType === TileColumnDataType.DATE) {
            this.displayList = [{ id: '0', value: 'Date and Time' }, { id: '1', value: 'Date Only' }, { id: '2', value: 'Month and Year' }, { id: '3', value: 'Year Only' }];
            this.selectedDisplay = this.displayList.find(item => item.id === this.config.settings.display);
            this.hasDisplay = true;
        } else {
            this.selectedDataType = this.dataTypeList.find(item => item.id === this.config.dataType);
            this._afterDataTypeChange();
        }
    }

    ngOnDestroy(): void {
    }

    onDataTypeChange(value) {
        this.selectedDataType = value;
        this.config.dataType = this.selectedDataType.id;
        this._afterDataTypeChange();
        if (this.briefConfig) {
            this.briefConfig.feedbackSubject$.next(this.isNumber);
        }
    }

    onDecimalPlacesChange(value) {
        this.selectedDecimalPlaces = value;
        this.config.settings.decimalPlaces = this.selectedDecimalPlaces.id;
    }

    onDisplayChange(value) {
        this.selectedDisplay = value;
        if (!this.config.settings) {
            this.config.settings = new TileColumnSetting();
        }
        this.config.settings.display = this.selectedDisplay.id;
    }

    onMultiplyBy100Change(value) {
        this.multiplyBy100 = value;
        this.config.settings.multiplyBy100 = this.multiplyBy100;
    }

    onScaleChange(value) {
        this.selectedScale = value;
        this.config.settings.scale = this.selectedScale.id;
    }

    private _afterDataTypeChange() {
        if (!this.selectedDataType) {
            return;
        }
        if (this.selectedDataType.id === 'text') {
            this.isPercent = false;
            this.isRatio = false;
            this.selectedDecimalPlaces = null;
            this.selectedScale = null;
            this.multiplyBy100 = null;
            this.isNumber = false;
            if (this.config.settings) {
                const tempSettings = new TileColumnSetting();
                if (this.config.settings.display) {
                    tempSettings.display = this.config.settings.display;
                }
                this.config.settings = tempSettings;
            }
        } else {
            this.isNumber = true;
            if (!this.config.settings) {
                this.config.settings = new TileColumnSetting();
            }
            if (!this.config.settings.negatives) {
                this.config.settings.negatives = 1;
            }
            if (this.config.settings.decimalPlaces) {
                this.selectedDecimalPlaces = this.decimalPlacesList.find(item => item.id === this.config.settings.decimalPlaces);
            } else {
                this.selectedDecimalPlaces = this.decimalPlacesList[2];
                this.config.settings.decimalPlaces = this.selectedDecimalPlaces.id;
            }
            if (this.selectedDataType.id === TileColumnDataType.PERCENT) {
                if (this.config.settings.multiplyBy100 !== null && this.config.settings.multiplyBy100 !== undefined) {
                    this.multiplyBy100 = this.config.settings.multiplyBy100;
                } else {
                    this.multiplyBy100 = true;
                    this.config.settings.multiplyBy100 = this.multiplyBy100;
                }
                this.isPercent = true;

                this.isRatio = false;
                this._clearScale();
            } else if (this.selectedDataType.id === TileColumnDataType.RATIO) {
                this.isRatio = true;

                this.isPercent = false;
                this._clearScale();
                this._clearMultiplyBy100();
            } else {
                if (this.config.settings.scale) {
                    this.selectedScale = this.scaleList.find(item => item.id === this.config.settings.scale);
                } else {
                    this.selectedScale = this.scaleList[0];
                    this.config.settings.scale = this.selectedScale.id;
                }

                this.isPercent = false;
                this.isRatio = false;
                this._clearMultiplyBy100();
            }
        }
    }

    private _clearMultiplyBy100() {
        this.multiplyBy100 = null;
        if (this.config.settings && this.config.settings.multiplyBy100 !== null && this.config.settings.multiplyBy100 !== undefined) {
            delete this.config.settings.multiplyBy100;
        }
    }

    private _clearScale() {
        this.selectedScale = null;
        if (this.config.settings && this.config.settings.scale) {
            delete this.config.settings.scale;
        }
    }

}
